import type { User } from '@/entities/auth/model/authSchema';

/** С «главной» (`/`) сотрудника ведём на карточку, а не на дашборд. Сохраняем глубокие ссылки из `from`. */
export function resolvePostLoginPath(user: User, from: string): string {
  const trimmed = from.trim();
  const isDashboardEntry = trimmed === '' || trimmed === '/';
  if (user.role === 'employee' && user.employee_id && isDashboardEntry) {
    return `/employees?employeeId=${encodeURIComponent(user.employee_id)}`;
  }
  return trimmed || '/';
}
